import { useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { postSpvEnrollSca, postSpvScaConsent, postSpvScaRefresh } from 'src/api/stoApi';
import { MangopayReadiness } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useSpvSca = () => {
  const [readiness, setReadiness] = useState<MangopayReadiness | null>(null);

  const refresh = async (spvId: string): Promise<MangopayReadiness | null> => {
    generalStore.setIsLoading(true);
    try {
      const response = (await postSpvScaRefresh(spvId)).data;
      setReadiness(response.data);
      return response.data;
    } catch (error: any) {
      apiErrorHandling(error);
      return null;
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  const startConsent = async (spvId: string): Promise<string | null> => {
    generalStore.setIsLoading(true);
    try {
      const response = (await postSpvScaConsent(spvId)).data;
      return response.data.redirectUrl;
    } catch (error: any) {
      apiErrorHandling(error);
      return null;
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  const enroll = async (spvId: string): Promise<string | null> => {
    generalStore.setIsLoading(true);
    try {
      const response = (await postSpvEnrollSca(spvId)).data;
      return response.data.redirectUrl;
    } catch (error: any) {
      apiErrorHandling(error);
      return null;
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  return { readiness, refresh, startConsent, enroll };
};
